import {RECEIVED_LEADS, REQUEST_LEADS_FAILED, REQUESTED_LEADS} from '../actions/GetLeads';
import {
  NO_MORE_LEADS,
  RECEIVED_MORE_LEADS,
  REQUEST_MORE_LEADS_FAILED,
  REQUESTED_MORE_LEADS
} from '../actions/GetMoreLeads';
import {LEAD_PLACES_REDUCED} from '../actions/LeadPlacesReduced';
import {LEAD_PLACES_EXHAUSTED} from '../actions/LeadPlacesExhausted';
import {ADD_LEAD_TO_FEED} from '../actions/AddLeadToFeed';

const initialState = {
  loading: true,
  loading_more: false,
  no_more_leads: false,
  data: [],
  next_page_url: null,
  params: {
    order_by: 'combined_date',
  },
};

const leads = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTED_LEADS:
      return initialState;
    case RECEIVED_LEADS:
      return {
        data: action.leads,
        params: action.params,
        loading: false,
        next_page_url: action.next_page_url,
        no_more_leads: action.total === 0,
        num_leads_total: action.total,
        num_leads_available: action.total - (action.to ? action.to : 0),
      };
    case REQUEST_LEADS_FAILED:
      return Object.assign({}, initialState, {
        loading: false,
      });
    case REQUESTED_MORE_LEADS:
      return Object.assign({}, state, {
        loading_more: true,
      });
    case RECEIVED_MORE_LEADS:
      return Object.assign({}, state, {
        data: [...state.data, ...action.leads],
        loading_more: false,
        next_page_url: action.next_page_url,
        num_leads_total: action.total,
        num_leads_available: action.total - (action.to ? action.to : 0),
      });
    case REQUEST_MORE_LEADS_FAILED:
      return Object.assign({}, state, {
        loading_more: false,
      });
    case LEAD_PLACES_REDUCED:
      return Object.assign({}, state, {
        data: state.data.map((lead) => {
          if (lead.id === action.lead.id) {
            return Object.assign({}, lead, {
              places: action.lead.places,
            });
          }
          return lead;
        }),
      });
    case LEAD_PLACES_EXHAUSTED:
      return Object.assign({}, state, {
        data: state.data.filter(lead => lead.id !== action.lead.id),
      });
    case ADD_LEAD_TO_FEED:
      return Object.assign({}, state, {
        data: [...state.data, action.lead],
      });
    case NO_MORE_LEADS:
      return Object.assign({}, state, {
        no_more_leads: true,
      });
    default:
      return state;
  }
};

export default leads;
